import useUserStore from "~/stores/user";

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUserStore();

  if (!userStore.isAuthenticated)
    // return abortNavigation("Unauthorized!");
    return navigateTo({ path: "/auth/login/", query: { redirectUrl: to.fullPath } });
});
